import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/pharmacovigilance/farmacovigilancia-formacion-combinada-certificada")({
  head: () => buildRouteHead("/es/servicios/pharmacovigilance/farmacovigilancia-formacion-combinada-certificada"),
  component: PVOffering,
});

